"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcoaCrf = exports.EcoaCrfStatus = void 0;
var EcoaCrfStatus;
(function (EcoaCrfStatus) {
    EcoaCrfStatus["NotAvailable"] = "NOT_AVAILABLE";
    EcoaCrfStatus["NotDone"] = "NOT_DONE";
    EcoaCrfStatus["Ongoing"] = "ONGOING";
    EcoaCrfStatus["Done"] = "DONE";
})(EcoaCrfStatus = exports.EcoaCrfStatus || (exports.EcoaCrfStatus = {}));
class EcoaCrf {
}
exports.EcoaCrf = EcoaCrf;
//# sourceMappingURL=ecoaCrf.js.map